exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".progress-indicator {\n  text-align: center;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex; }\n  .progress-indicator .progress-bar-container {\n    border: 1px solid #cfcfcf;\n    -webkit-box-flex: 4;\n        -ms-flex: 4;\n            flex: 4; }\n    .progress-indicator .progress-bar-container .progress-bar {\n      background: #2CC185;\n      height: 1em; }\n  .progress-indicator .info {\n    margin-left: .3em;\n    -webkit-box-flex: 1.5;\n        -ms-flex: 1.5;\n            flex: 1.5; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/common/components/ProgressIndicatorComponent/progressIndicator.component.scss
// module id = ./src/app/common/components/ProgressIndicatorComponent/progressIndicator.component.scss
// module chunks = main